import { Component } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-user-detail',
    templateUrl: './breadcrumb.user.detail.component.html'
})

export class BreadcrumbUserDetailComponent { }
